import { render } from "./skins.vue?vue&type=template&id=802ea954"
import script from "./skins.vue?vue&type=script&lang=js"
export * from "./skins.vue?vue&type=script&lang=js"

import exportComponent from "../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__